import { axiosInstance } from "./index";

export interface ShortUrl {
	code: string;
	targetUrl: string;
	createdBy: string;
	createdAt: string;
}

export async function createShortUrl(targetUrl: string): Promise<ShortUrl> {
	const response = await axiosInstance.post<ShortUrl>("/short-urls", { targetUrl });
	return response.data;
}

export async function resolveShortUrl(code: string): Promise<ShortUrl> {
	const response = await axiosInstance.get<ShortUrl>(`/short-urls/${code}`);
	return response.data;
}

export function buildShortUrl(code: string, targetUrl: string): string {
	const prefix = targetUrl.startsWith("/") ? "/r/" : "/p/";
	return `${window.location.origin}${prefix}${code}`;
}
